import type { LucideIcon } from 'lucide-react';
import { cn } from '@bliks-io/ui';

interface PartnerInfoPanelProps {
  icon: LucideIcon;
  /** Already-translated headline, e.g. "Partner admins only". */
  title: string;
  description?: string;
  className?: string;
}

/**
 * Centered icon + explanation for an expected empty state in the partner area
 * ("admin only", "not linked to HubSpot"). Deliberately not an error UI: these
 * states are the product working as designed, whether the client knew upfront
 * (a role check) or learned it from a 403.
 */
export function PartnerInfoPanel({
  icon: Icon,
  title,
  description,
  className
}: PartnerInfoPanelProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center flex-1 gap-2 text-center',
        className
      )}
    >
      <Icon className="w-10 h-10 text-muted-foreground" strokeWidth={1.5} />
      <p className="font-medium text-foreground">{title}</p>
      {description && <p className="max-w-md text-sm text-muted-foreground">{description}</p>}
    </div>
  );
}
